module.exports = __webpack_public_path__ + "static/media/Mini-PLL.cc74f31b.jpg";